export { default } from "./PostSectionHeading";
